import './fontawesome'
import WebFont from 'webfontloader'
import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/css/intlTelInput.css' // optional

// ---- App settings exposed on window ----
const jsonSettings = document.querySelector(
  '[data-settings-selector="settings-json"]',
)
window.settings = jsonSettings ? JSON.parse(jsonSettings.textContent) : {}
window.locale = document.documentElement.lang || 'lt'

//export default (createApp) => {
// 1) Fonts
WebFont.load({
  google: { families: ['Muli:400,700,800,900', 'Nunito+Sans'] },
})

// 2) Mount Vue app if #app exists
/*const mountEl = document.getElementById('app')
if (mountEl) {
  const { app } = createApp()
  app.$mount('#app')
}*/

// 3) Telephone inputs (intl-tel-input is already vanilla)
document.querySelectorAll('input[type="tel"]').forEach((input) => {
  intlTelInput(input, {
    // tweak as needed; this is just a sane default
    initialCountry: 'auto',
    utilsScript: undefined,
  })
})

// 4) SweetAlert2 confirm buttons (no jQuery needed)
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-toggle="confirm"]')
  if (!btn) return
  e.preventDefault()

  // Lazy-load to keep initial bundle small
  const { default: Swal } = await import('sweetalert2')
  const title = btn.getAttribute('data-trans-title') || 'Are you sure?'
  const cancelText = btn.getAttribute('data-trans-button-cancel') || 'Cancel'
  const confirmText = btn.getAttribute('data-trans-button-confirm') || 'OK'

  const res = await Swal.fire({
    title,
    icon: 'warning',
    showCancelButton: true,
    cancelButtonText: cancelText,
    confirmButtonText: confirmText,
    confirmButtonColor: '#dd4b39',
  })

  if (res.isConfirmed || res.value) {
    const form = btn.closest('form')
    if (form) form.submit()
    else if (btn.tagName === 'A') window.location.assign(btn.href)
  }
})

// 5) “Save” toggler
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.save')
  if (btn) btn.classList.toggle('saved')
})

// 6) Stop dropdown hiding on inner click
document
  .querySelectorAll('.dropdown.selection .dropdown-menu')
  .forEach((menu) => {
    menu.addEventListener('click', (e) => e.stopPropagation())
  })

// 7) Delete actions (simple native confirm)
document.addEventListener('click', (e) => {
  const btn = e.target.closest('a.delete-action, button.delete-action')
  if (!btn) return
  e.preventDefault()

  if (window.confirm('Are you sure you want to delete ?')) {
    if (btn.tagName === 'A') {
      const url = btn.getAttribute('href')
      if (url) window.location.assign(url)
    } else {
      const form = document.querySelector('form[name="listForm"]')
      if (form) form.submit()
    }
  }
})

// 8) Navbar overflow + height parity (BootstrapVue-friendly)
const html = document.documentElement
const collapse = () => document.querySelector('.navbar-collapse')

const togglerStateRefresh = () => {
  const toggler = document.querySelector('.navbar-toggler')
  if (!toggler) return
  const expanded = !toggler.classList.contains('collapsed')
  html.style.overflowY = expanded ? 'hidden' : 'auto'
  const c = collapse()
  if (c) c.style.height = expanded ? '100vh' : 'auto'
}

const closeNavbar = () => {
  const toggler = document.querySelector('.navbar-toggler')
  const targetSelector =
    toggler?.getAttribute('data-target') ||
    toggler?.getAttribute('data-bs-target')
  if (!toggler || !targetSelector) return
  const target = document.querySelector(targetSelector)
  if (!target) return

  toggler.classList.add('collapsed')
  toggler.setAttribute('aria-expanded', 'false')
  target.classList.remove('show')
  togglerStateRefresh()
}

document.addEventListener('click', (e) => {
  const toggler = e.target.closest('.navbar-toggler')
  if (!toggler) return

  e.preventDefault()
  const targetSelector =
    toggler.getAttribute('data-target') ||
    toggler.getAttribute('data-bs-target')
  if (!targetSelector) return
  const target = document.querySelector(targetSelector)
  if (!target) return

  const willOpen = toggler.classList.contains('collapsed')

  if (willOpen) {
    toggler.classList.remove('collapsed')
    toggler.setAttribute('aria-expanded', 'true')
    target.classList.add('show')
  } else {
    toggler.classList.add('collapsed')
    toggler.setAttribute('aria-expanded', 'false')
    target.classList.remove('show')
  }

  togglerStateRefresh()
})

document.addEventListener('click', (e) => {
  const link = e.target.closest(
    '.navbar-collapse .nav-link, .navbar-collapse .dropdown-item',
  )
  if (!link) return
  const toggler = document.querySelector('.navbar-toggler')
  if (
    window.innerWidth >= 992 ||
    !toggler ||
    toggler.classList.contains('collapsed')
  ) {
    return
  }
  closeNavbar()
})
window.addEventListener('resize', () => {
  const width = window.innerWidth
  const toggler = document.querySelector('.navbar-toggler')
  const c = collapse()
  if (!toggler || !c) return
  if (width >= 991 && !toggler.classList.contains('collapsed')) {
    window.scrollTo(0, 0)
    c.style.height = '100vh'
  } else if (toggler.classList.contains('collapsed')) {
    c.style.height = 'auto'
  }
})

// 9) Equalize heights helper (consider replacing with CSS flex)
function equalize(selector) {
  const nodes = Array.from(document.querySelectorAll(selector))
  if (nodes.length === 0) return
  nodes.forEach((n) => (n.style.height = 'auto'))
  //const max = nodes.reduce((m, n) => Math.max(m, n.offsetHeight), 0)
  //nodes.forEach((n) => (n.style.height = `${max}px`))
}
window.addEventListener('load', () => equalize('.col-service-form label'))
window.addEventListener('resize', () => equalize('.col-service-form label'))

// Optional: tab “active” state if you still rely on it
document.addEventListener('click', (e) => {
  const tabLi = e.target.closest('.nav-tabs li')
  if (!tabLi) return
  document
    .querySelectorAll('.nav-tabs li.active')
    .forEach((li) => li.classList.remove('active'))
  tabLi.classList.add('active')
})

// Smooth scroll example (left disabled)
// document.querySelectorAll('a[href^="#"]').forEach(a => {
//   a.addEventListener('click', (event) => {
//     const target = document.querySelector(a.getAttribute('href'))
//     if (!target) return
//     event.preventDefault()
//     window.scrollTo({ top: target.offsetTop, behavior: 'smooth' })
//   })
// })
//}

function setupNavDropdowns({ hover = true } = {}) {
  const DROPDOWN_SELECTOR = '.nav-item.dropdown'
  const TOGGLE_SELECTOR = '.dropdown-toggle'
  const MENU_SELECTOR = '.dropdown-menu'

  const dropdowns = Array.from(document.querySelectorAll(DROPDOWN_SELECTOR))

  const closeAll = () => {
    dropdowns.forEach((dd) => {
      dd.classList.remove('show')
      const menu = dd.querySelector(MENU_SELECTOR)
      const toggle = dd.querySelector(TOGGLE_SELECTOR)
      if (menu) menu.classList.remove('show')
      if (toggle) toggle.setAttribute('aria-expanded', 'false')
    })
  }

  const open = (dd) => {
    const menu = dd.querySelector(MENU_SELECTOR)
    const toggle = dd.querySelector(TOGGLE_SELECTOR)
    if (!menu || !toggle) return
    // close siblings
    dropdowns.forEach((other) => {
      if (other !== dd) {
        other.classList.remove('show')
        const om = other.querySelector(MENU_SELECTOR)
        const ot = other.querySelector(TOGGLE_SELECTOR)
        if (om) om.classList.remove('show')
        if (ot) ot.setAttribute('aria-expanded', 'false')
      }
    })
    dd.classList.add('show')
    menu.classList.add('show')
    toggle.setAttribute('aria-expanded', 'true')
  }

  const toggle = (dd) => {
    if (dd.classList.contains('show')) {
      closeAll()
    } else {
      open(dd)
    }
  }

  // Click to open/close
  document.addEventListener('click', (e) => {
    const toggleEl = e.target.closest(`${DROPDOWN_SELECTOR} ${TOGGLE_SELECTOR}`)
    if (toggleEl) {
      e.preventDefault()
      const dd = toggleEl.closest(DROPDOWN_SELECTOR)
      toggle(dd)
      return
    }
    // Click outside closes all
    if (!e.target.closest(DROPDOWN_SELECTOR)) {
      closeAll()
    }
  })

  // Optional: hover open on non-touch / fine pointer devices
  if (
    hover &&
    window.matchMedia('(hover: hover) and (pointer: fine)').matches
  ) {
    dropdowns.forEach((dd) => {
      dd.addEventListener('mouseenter', () => open(dd))
      dd.addEventListener('mouseleave', () => closeAll())
    })
  }

  // Escape closes
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll()
  })

  // Keep clicks inside menu from closing parent unexpectedly
  document
    .querySelectorAll(`${DROPDOWN_SELECTOR} ${MENU_SELECTOR}`)
    .forEach((menu) => {
      menu.addEventListener('click', (e) => e.stopPropagation())
    })
}

setupNavDropdowns({ hover: true })
